'use client';

import { VideoRow, type VideoRowProps } from '../rail/VideoRow';

/**
 * Module-pinned video rail — same shape as {@code VideoRow} but
 * defaults to the {@code editor-picks} source, matching the video
 * module's curated rails.
 */
export type VideoModuleRailProps = VideoRowProps;

export function VideoModuleRail(props: VideoModuleRailProps) {
  return <VideoRow source={props.source || 'editor-picks'} {...props} />;
}
